var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticle56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5 7C15.2239 7 15 7.22386 15 7.5V45.5C15 46.4283 14.6313 47.3185 13.9749 47.9749C13.3185 48.6313 12.4283 49 11.5 49C10.5717 49 9.6815 48.6312 9.02513 47.9749C8.36875 47.3185 8 46.4283 8 45.5V30H10.5C10.7761 30 11 29.7761 11 29.5C11 29.2239 10.7761 29 10.5 29H7.5C7.22386 29 7 29.2239 7 29.5V45.5C7 46.6935 7.47411 47.8381 8.31802 48.682C9.16193 49.5259 10.3065 50 11.5 50H45.5C46.6935 50 47.8381 49.5259 48.682 48.682C49.5259 47.8381 50 46.6935 50 45.5V7.5C50 7.22386 49.7761 7 49.5 7H15.5ZM45.5 49H14.3285C14.4513 48.9008 14.5693 48.7947 14.682 48.682C15.5259 47.8381 16 46.6935 16 45.5V8H49V45.5C49 46.4283 48.6313 47.3185 47.9749 47.9749C47.3185 48.6313 46.4283 49 45.5 49Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 15C22.2239 15 22 15.2239 22 15.5V23.5C22 23.7761 22.2239 24 22.5 24H42.5C42.7761 24 43 23.7761 43 23.5V15.5C43 15.2239 42.7761 15 42.5 15H22.5ZM23 23V16H42V23H23ZM22 31.5C22 31.2239 22.2239 31 22.5 31H42.5C42.7761 31 43 31.2239 43 31.5C43 31.7761 42.7761 32 42.5 32H22.5C22.2239 32 22 31.7761 22 31.5ZM22 39.5C22 39.2239 22.2239 39 22.5 39H42.5C42.7761 39 43 39.2239 43 39.5C43 39.7761 42.7761 40 42.5 40H22.5C22.2239 40 22 39.7761 22 39.5Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgArticle56;